(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evisu-rules"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const navigationItems = document.querySelectorAll('.navigation-item');
    const sections = document.querySelectorAll('.section');

    navigationItems.forEach(item => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        const sectionIndex = item.getAttribute('data-section');
        const section = document.querySelector('.section-' + sectionIndex);
        window.scrollTo({
          top: section.offsetTop,
          behavior: 'smooth'
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.querySelector('.section-header-top');
            this.headerInner = document.querySelector('.section-header');
            this.announcementBar = document.querySelector('.announcement-bar-section');

            this.headerIsAlwaysSticky =
            this.getAttribute('data-sticky-type') === 'always' ||
            this.getAttribute('data-sticky-type') === 'reduce-logo-size';

            this.headerBounds = {};

            this.setHeaderHeight();
            this.setHeaderInnerHeight();
            this.setAnnouncementHeight();

            window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            }

            this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');

            this.isScrolledPastHeader = this.header.classList.contains('scrolled-past-header');
            this.lastHandledScrollTop = this.currentScrollTop;
            this.scrollDirectionThreshold = 10;
            this.ignoreScrollUntil = 0;
            this.scrollRaf = null;
            this.syncScrollTimer = null;

            this.onScrollHandler = this.onScroll.bind(this);
            this.onResizeHandler = this.setAnnouncementHeight.bind(this);

            this.hideHeaderOnScrollUp = () => this.preventReveal = true;

            window.addEventListener('resize', this.onResizeHandler);
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, { passive: true });

            this.createObserver();

            requestAnimationFrame(() => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

            this.lastHandledScrollTop = scrollTop;

            if (scrollTop > 0) {
                this.setScrolledPastHeader(true);
            }
            });
        }

        setHeaderHeight() {
            document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        setHeaderInnerHeight() {
            document.documentElement.style.setProperty('--header-inner-height', `${this.headerInner.offsetHeight}px`);
        }

        setAnnouncementHeight() {
            document.documentElement.style.setProperty('--announcement-height', `${this.announcementBar?.offsetHeight || 0}px`);
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
            window.removeEventListener('resize', this.onResizeHandler);

            if (this.scrollRaf) {
            cancelAnimationFrame(this.scrollRaf);
            }

            window.clearTimeout(this.syncScrollTimer);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
            });

            observer.observe(this.header);
        }

        setScrolledPastHeader(shouldAdd) {
            if (this.isScrolledPastHeader === shouldAdd) return;

            this.isScrolledPastHeader = shouldAdd;
            this.header.classList.toggle('scrolled-past-header', shouldAdd);

            window.clearTimeout(this.syncScrollTimer);

            this.ignoreScrollUntil = Date.now() + 280;

            this.syncScrollTimer = window.setTimeout(() => {
            this.lastHandledScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
            }, 300);
        }

        onScroll() {
            if (this.scrollRaf) return;

            this.scrollRaf = requestAnimationFrame(() => {
            this.scrollRaf = null;

            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
            const now = Date.now();

            if (scrollTop <= 0) {
                this.setScrolledPastHeader(false);
                requestAnimationFrame(this.reset.bind(this));
                this.lastHandledScrollTop = 0;
                return;
            }

            if (now < this.ignoreScrollUntil) {
                return;
            }

            const diff = scrollTop - this.lastHandledScrollTop;

            if (Math.abs(diff) < this.scrollDirectionThreshold) {
                return;
            }

            if (diff > 0) {
                this.setScrolledPastHeader(true);
            } else {
                this.setScrolledPastHeader(false);
            }

            this.lastHandledScrollTop = scrollTop;
            });
        }

        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.closeMenuDisclosure();
            this.closeSearchModal();
        }

        reveal() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
        }

        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
            this.disclosures.forEach(disclosure => disclosure.close());
        }

        closeSearchModal() {
            this.searchModal = this.searchModal || this.header.querySelector('details-modal');
            this.searchModal.close(false);
        }
    }
    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
